module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.title) ? _c('v-card-title', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('a', {
    attrs: {
      "target": "_top",
      "href": _vm.snapUrl
    }
  }, [_c('img', {
    staticStyle: {
      "min-width": "150px",
      "min-height": "150px"
    },
    attrs: {
      "src": _vm.snapImg
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('info')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6936a843","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SnapCode.vue
// module id = 1455
// module chunks = 9